// Constans
window.cons = {
    DELAY: 50,
    ANIMATION_TIME: 300
};

// Toggle Panel
var TogglePanel = (function () {
    var id = {
        _target: 'data-toggle-trigger',
        _destination: 'data-toggle-target',
        _parent: 'data-toggle-parent'
    }
    $(document).on('click', '[data-toggle-trigger]', TogglePanel);

    function TogglePanel() {
        // To check if is not visible with css in any resolution
        if (!$(this).find('.btn-toggle').is(':visible') && !$(this).hasClass('is-toggle')) return;

        var target = this.getAttribute(id._target),
            parent = this.getAttribute(id._parent);

        var $panel = (parent != null) ? $(this).parents(parent).find('[' + id._destination + '=' + target + ']') :
            $('[' + id._destination + '=' + target + ']');
        if ($panel.length == 0) return;


        $panel.slideToggle(cons.ANIMATION_TIME);
        if (this.classList.contains('is-toggle') || this.classList.contains('is-text-toggle')) {
            this.classList.toggle('is-toggled');
        } else {
            var $toggleBtn = $(this).find('.btn-toggle');
            if ($toggleBtn.length > 0) $toggleBtn.toggleClass('is-toggled');
        }
    }
})();

// DOM READY EXECUTION
(function () {

    // Search Block
    $("#search_block_top").each(function () {
        $("#search-icon").click(function () {
            $("#searchbox").toggleClass("show");
        });
    });

    // Vertical Menu
    $(".verticalmenu .caret").click(function () {
        var $parent = $(this).parent();
        $parent.toggleClass('open');
        return false;
    });

})();